import model from '../models-v2/crm/agreement-price-increase';
import routeName from './route-name';

export default [
  {
    path: '/crm/agreements/price-increases',
    name: routeName.crmAgreementPriceIncrease.index,
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../views/pages/clients_agreements/price-increase/top-right-section.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'Indeksacja cen', url: '/crm/agreements/price-increases' },
      ],
      rule: 'editor',
      search: false,
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
];
